import { DealDetail, SignalType } from 'api'
import { DevSignalActions } from 'api/DevSignalActions'
import { Locale, Translation } from 'locale'
import { useDispatch, useSelector } from 'react-redux'
import { canTriggerSupportActionsSelector } from 'selectors/permissionSelectors'

export const useCommonDealActionItems = (items: DealDetail[]) => {
  const dispatch = useDispatch()
  const canTriggerSupportActions = useSelector(canTriggerSupportActionsSelector)
  return [
    {
      label: Locale.translate(Translation.TC_BUTTON_REFRESH, { count: items.length }),
      onClick: () => {
        dispatch(
          DevSignalActions.triggerRefreshDeals(
            SignalType.REFRESH_DEALS,
            undefined,
            items.map(dealDetail => dealDetail.deal.dealId)
          )
        )
      },
      enabled: canTriggerSupportActions
    }
  ]
}
